export const FETCH_SERVICES = 'service/FETCH_SERVICES'
export const FETCH_SERVICES_SUCCESS = 'service/FETCH_SERVICES_SUCCESS'
export const FETCH_SERVICES_FAILURE = 'service/FETCH_SERVICES_FAILURE'
export const RESET_SERVICES = 'service/RESET_SERVICES'

export const FETCH_SERVICES_OFFER = 'service/FETCH_SERVICES_OFFER'
export const FETCH_SERVICES_OFFER_SUCCESS = 'service/FETCH_SERVICES_OFFER_SUCCESS'
export const FETCH_SERVICES_OFFER_FAILURE = 'service/FETCH_SERVICES_OFFER_FAILURE'
export const RESET_SERVICES_OFFER = 'service/RESET_SERVICES_OFFER'

export const FETCH_SERVICE = 'service/FETCH_SERVICE'
export const FETCH_SERVICE_SUCCESS = 'service/FETCH_SERVICE_SUCCESS'
export const FETCH_SERVICE_FAILURE = 'service/FETCH_SERVICE_FAILURE'
export const RESET_SERVICE = 'service/RESET_SERVICE'

export const CREATE_SERVICE = 'service/CREATE_SERVICE'
export const CREATE_SERVICE_SUCCESS = 'service/CREATE_SERVICE_SUCCESS'
export const CREATE_SERVICE_FAILURE = 'service/CREATE_SERVICE_FAILURE'
export const RESET_CREATE_SERVICE = 'service/RESET_CREATE_SERVICE'

export const UPDATE_SERVICE = 'service/UPDATE_SERVICE'
export const UPDATE_SERVICE_SUCCESS = 'service/UPDATE_SERVICE_SUCCESS'
export const UPDATE_SERVICE_FAILURE = 'service/UPDATE_SERVICE_FAILURE'
export const RESET_UPDATE_SERVICE = 'service/RESET_UPDATE_SERVICE'

export const DELETE_SERVICE = 'service/DELETE_SERVICE'
export const DELETE_SERVICE_SUCCESS = 'service/DELETE_SERVICE_SUCCESS'
export const DELETE_SERVICE_FAILURE = 'service/DELETE_SERVICE_FAILURE'
export const RESET_DELETE_SERVICE = 'service/RESET_DELETE_SERVICE'


// WEBPACK FOOTER //
// ./src/store/service/actionTypes.js